export default __webpack_public_path__ + "static/media/money-back.08a8bc31.png";